// Mock data for Maidly website
import { houseCleaningIcon, cookingServicesIcon, houseHoldHelpIcon } from '../assets/assets';

export const services = [
  {
    id: 1,
    title: "House Cleaning",
    description: "Professional deep cleaning for your home. Trained staff with quality equipment.",
    icon: houseCleaningIcon,
    features: ["Deep Cleaning", "Regular Maintenance", "Eco-friendly Products"],
    startingPrice: "₹299"
  },
  {
    id: 2,
    title: "Plumbing Services",
    description: "Expert plumbers for repairs, installations, and maintenance.",
    icon: "Wrench",
    features: ["Leak Repairs", "Pipe Installation", "24/7 Emergency"],
    startingPrice: "₹199"
  },
  {
    id: 3,
    title: "Electrical Work",
    description: "Licensed electricians for all your electrical needs.",
    icon: "Zap",
    features: ["Wiring", "Appliance Repair", "Safety Checks"],
    startingPrice: "₹249"
  },
  {
    id: 4,
    title: "Cooking Services",
    description: "Skilled cooks for daily meals or special occasions.",
    icon: cookingServicesIcon,
    features: ["Daily Meals", "Party Catering", "Multiple Cuisines"],
    startingPrice: "₹399"
  },
  {
    id: 5,
    title: "Household Help",
    description: "Reliable helpers for daily household tasks.",
    icon: houseHoldHelpIcon,
    features: ["Daily Tasks", "Verified Staff", "Flexible Hours"],
    startingPrice: "₹349"
  },
  {
    id: 6,
    title: "Carpentry",
    description: "Skilled carpenters for furniture and woodwork.",
    icon: "Hammer",
    features: ["Furniture Repair", "Custom Work", "Installation"],
    startingPrice: "₹299"
  }
];

export const howItWorksSteps = [
  {
    step: 1,
    title: "Choose Your Service",
    description: "Browse our wide range of home services and select what you need.",
    icon: "Search"
  },
  {
    step: 2,
    title: "Book Instantly",
    description: "Pick a time slot that works for you and confirm your booking in seconds.",
    icon: "Calendar"
  },
  {
    step: 3,
    title: "Get Service",
    description: "Our verified professional arrives at your doorstep and completes the job.",
    icon: "CheckCircle"
  },
  {
    step: 4,
    title: "Rate & Review",
    description: "Share your experience to help us maintain quality standards.",
    icon: "Star"
  }
];

export const whyChooseMaidly = [
  {
    title: "Verified Professionals",
    description: "All service providers undergo thorough background verification.",
    icon: "ShieldCheck"
  },
  {
    title: "Transparent Pricing",
    description: "No hidden charges. See exact pricing before you book.",
    icon: "IndianRupee"
  },
  {
    title: "Quality Guarantee",
    description: "Not satisfied? We'll make it right or refund your money.",
    icon: "Award"
  },
  {
    title: "24/7 Support",
    description: "Round-the-clock customer support for any queries or issues.",
    icon: "Headphones"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Priya Sharma",
    location: "Mumbai",
    rating: 5,
    text: "Maidly has made my life so much easier! The cleaning service is excellent and the staff is very professional.",
    service: "House Cleaning"
  },
  {
    id: 2,
    name: "Rajesh Kumar",
    location: "Delhi",
    rating: 5,
    text: "Called a plumber at midnight for an emergency. He arrived in 30 minutes and fixed the issue. Highly recommended!",
    service: "Plumbing"
  },
  {
    id: 3,
    name: "Anita Desai",
    location: "Bangalore",
    rating: 5,
    text: "The cook they provided is amazing! My family loves the food and the service is very reliable.",
    service: "Cooking"
  },
  {
    id: 4,
    name: "Vikram Singh",
    location: "Pune",
    rating: 4,
    text: "Great service and transparent pricing. The electrician was very professional and completed work on time.",
    service: "Electrical"
  }
];

export const stats = [
  { value: "50,000+", label: "Happy Customers" },
  { value: "2,000+", label: "Verified Professionals" },
  { value: "100,000+", label: "Services Completed" },
  { value: "4.8/5", label: "Average Rating" }
];

export const faqs = [
  {
    question: "How do I book a service?",
    answer: "Simply browse our services, select what you need, choose a convenient time slot, and confirm your booking. You'll receive instant confirmation."
  },
  {
    question: "Are the professionals verified?",
    answer: "Yes! All our service professionals undergo thorough background verification, skill assessment, and training before they're allowed to take bookings."
  },
  {
    question: "What if I'm not satisfied with the service?",
    answer: "We have a 100% satisfaction guarantee. If you're not happy with the service, contact our support team and we'll either send another professional or provide a full refund."
  },
  {
    question: "Can I cancel or reschedule my booking?",
    answer: "Yes, you can cancel or reschedule up to 2 hours before the scheduled time without any charges. Cancellations within 2 hours may incur a small fee."
  },
  {
    question: "What are the payment methods accepted?",
    answer: "We accept all major payment methods including credit/debit cards, UPI, net banking, and digital wallets. You can also pay in cash after service completion."
  },
  {
    question: "Do you provide emergency services?",
    answer: "Yes! For plumbing and electrical emergencies, we offer 24/7 service. Just select the emergency option while booking."
  }
];

export const workerBenefits = [
  {
    title: "Flexible Working Hours",
    description: "Choose your own schedule and work according to your availability.",
    icon: "Clock"
  },
  {
    title: "Guaranteed Income",
    description: "Earn competitive rates with weekly payouts directly to your bank account.",
    icon: "Wallet"
  },
  {
    title: "Training & Support",
    description: "Get professional training and 24/7 support from our team.",
    icon: "GraduationCap"
  },
  {
    title: "Insurance Coverage",
    description: "All registered workers get accident insurance and health benefits.",
    icon: "Shield"
  },
  {
    title: "Growth Opportunities",
    description: "Build your reputation, get more bookings, and grow your income.",
    icon: "TrendingUp"
  },
  {
    title: "No Commission",
    description: "Keep 100% of your earnings during the first month. Low commission after.",
    icon: "Percent"
  }
];
